import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import IconButton from "@material-ui/core/IconButton";

import { activateBell, deactivateBell } from "../../../actions/projectmail";

const NotificationBellComponent = ({ type, bellActive, activateBellFn, deactivateBellFn }) => {
  const [hasbell] = useState(type !== "closed" && type !== "ticketHistory");
  return hasbell ? (
    <div>
      {bellActive ? (
        <IconButton onClick={() => deactivateBellFn(type)}>
          <NotificationsIcon />
        </IconButton>
      ) : (
        <IconButton onClick={() => activateBellFn(type)}>
          <NotificationsOffIcon />
        </IconButton>
      )}
    </div>
  ) : null;
};

NotificationBellComponent.propTypes = {
  type: PropTypes.string.isRequired,
  bellActive: PropTypes.bool.isRequired,
  activateBellFn: PropTypes.func.isRequired,
  deactivateBellFn: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  bellActive: state.projectmail.activeBellsForTicketType.indexOf(ownProps.type) > -1,
});

const mapDispatchToProps = dispatch => ({
  activateBellFn: type => dispatch(activateBell(type)),
  deactivateBellFn: type => dispatch(deactivateBell(type)),
});

const NotificationBell = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationBellComponent);

export default NotificationBell;
